/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ memory: NonNullable<unknown>, count: NonNullable<unknown> }} Team_Circles_LabelInputs */



/**
* | output |
* | --- |
* | "Conversation info for {memory} of {count} colleagues" |
*
* @param {Team_Circles_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_circles_label = /** @type {((inputs: Team_Circles_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Circles_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gespreksinfo voor ${i?.memory} van ${i?.count} collega's`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Infos d'entretien pour ${i?.memory} collègues sur ${i?.count}`)
	return /** @type {LocalizedString} */ (`Conversation info for ${i?.memory} of ${i?.count} colleagues`)
});